import React from 'react';
import OuvrirFenetrePartenaireSansImg from '../../components/OuvrirFenetrePartenaireSansImg';
import OuvrirFenetrePartenaire from '../../components/OuvrirFenetrePartenaire';

const MugsContent = () => {
    return (
        <div className="category-content">
            <h3 className="content-title">Mugs</h3>
            <div className="partner-section">
                <OuvrirFenetrePartenaireSansImg
                    sitePartenaire="https://www.esat-apf-jeanmuriel.fr/"
                    texteBoutonPartenaire="Mug créé en collaboration avec l'Esat Jean Muriel de Lunay"
                />
                <OuvrirFenetrePartenaire 
                    imageUrl="/ImgPartenaires/Mug3.png" 
                    sitePartenaire="https://www.esat-apf-jeanmuriel.fr/"
                    classPartenaire='product-image2'
                    altPartenaire='Esat Lunay'
                />
            </div>
        </div>
    );
};

export default MugsContent;
